import gql from 'graphql-tag';
import apolloClient from '../../apollo/apollo';

const state = {
    locales: ['ar', 'en'],
    locale: 'ar',
    language: {
        locale: 'ar',
        rtl: 'rtl',
        direction: 'right',
    },
    direction: true,
    messages: 'success',
    loading: false,
    drawer: null,
    miniDrawer: false,
    selectedBranchId: null,
    branches: [],
};

const getters = {

    getLocal(state) {
        return state.locale;
    },
    getLanguage(state) {
        return state.language;
    },
    getDirection(state) {
        return state.direction;
    },
    getMessages(state) {
        return state.messages;
    },
    getLoading(state) {
        return state.loading;
    },
    getDrawer(state) {
        return state.drawer;
    },
    getMiniDrawer(state) {
        return state.miniDrawer;
    },
    getSelectedBranchId(state) {
        return state.selectedBranchId;
    },
    getBranches(state) {
        return state.branches;
    },


};

const mutations = {
    setDrawer: (state,property) => {
        state.drawer = property
    },
    setMiniDrawer: (state,property) => {
        state.miniDrawer = !property
    },
    setSelectedBranchId: (state, branchId) => {
        state.selectedBranchId = branchId;
    },
    setBranches: (state, branches) => {
        state.branches = branches;
    },

    SET_LANG(state, locale) {
        if (state.locales.includes(locale.locale)) {
            state.locale = locale.locale
            state.language = locale
        }
    },
    projectDirection: (state, lang) => {
        if (lang === 'ar') {
            state.direction = true
        }
        if (lang !== 'ar') {
            state.direction = false
        }
    },
    successMessage: (state, data) => {
        Vue.notify({
            duration: 6000,
            speed: 400,
            type: 'success',
            group: 'successmesages',
            closeOnClick: true,
            text: 'apisuccessmesages.title' ,
            // title: 'apisuccessmesages.title' + data,
        })

        state.messages = 'success'
    },
    failMessage: (state, data) => {
        Vue.notify({
            duration: 6000,
            speed: 400,
            type: 'error',
            group: 'failmessages',
            text: 'apifailmessages.apifail' ,
            title: 'apifailmessages.title',
        })

        state.messages = 'error'
    },
    loadingFinish: (state) => {
        // console.log('dsf')
        state.loading = false
    },
    toggleDrawer: (state) => {
        state.drawer = !state.drawer
    },
    loadingStart: (state) => {
        // console.log('dsf')
        state.loading = true
    },

};

const actions = {
    setDrawerAction({commit}, property) {
        commit('setDrawer', property)
    },
    toggleDrawerAction({commit}, property) {
        commit('toggleDrawer', property)
    },
    setMiniDrawerAction({commit}, property) {
        commit('setMiniDrawer', property)
    },
    setSelectedBranchIdAction({commit}, branchId) {
        commit('setSelectedBranchId', branchId);
    },
    async fetchBranches({commit}) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findAllBranches {
                        findAllBranches {
                            id
                            name
                            status
                        }
                    }
                `,
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            commit('setBranches', response.data.findAllBranches);
        } catch (error) {
            console.error("Failed to fetch branches:", error);
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
};
